import { render, staticRenderFns } from "./organizationInfo.vue?vue&type=template&id=76250296&scoped=true&"
import script from "./organizationInfo.vue?vue&type=script&lang=js&"
export * from "./organizationInfo.vue?vue&type=script&lang=js&"
import style0 from "./organizationInfo.vue?vue&type=style&index=0&id=76250296&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76250296",
  null
  
)

export default component.exports